import { useTranslation } from "react-i18next";

import { Avatar, Flex, Input, List, Menu, Space, Tooltip } from "antd";

import styles from "../styles/MyTeamCalendar.module.css";
import { useEffect, useMemo, useState } from "react";
import { ReactComponent as UserIcon } from "../../../assets/icon/userIcon.svg";

function EmployeeList({
  employeeList = () => { },
  getWorkInCalendar = () => { },
  pagination = {},
  setPagination = () => { },
  total = 0,
  isLoading = false,
  setTotal = () => { },
  setEmployeeTeam = () => { },
  setEmployeeName = () => { },
  getAllEmployee = () => { }
}) {
  const { t, i18n } = useTranslation();
  const [search, setSearch] = useState(null)
  const [selectedKey, setSelectedKey] = useState(null);
  const { Search } = Input;
  const employees = useMemo(() => employeeList(), [employeeList]);

  useEffect(() => {
    if (employees && employees.length > 0) {
      const firstEmployee = employees[0];
      setSelectedKey(firstEmployee.key);
      setEmployeeTeam(firstEmployee.key);
      setEmployeeName(
        i18n.language === "en"
          ? `${firstEmployee.tab.nameEn} ${firstEmployee.tab.surNameEn}`
          : `${firstEmployee.tab.name} ${firstEmployee.tab.surName}`
      );
      getWorkInCalendar(firstEmployee.tab.empId);
    }
  }, [employees, i18n.language]);

  const handleMenuClick = (item) => {
    setSelectedKey(item.key);
    setEmployeeTeam(item.key);
    setEmployeeName(
      i18n.language === "en"
        ? `${item.tab.nameEn} ${item.tab.surNameEn}`
        : `${item.tab.name} ${item.tab.surName}`
    );
    getWorkInCalendar(item?.tab?.empId);
  };

  function Employee(item = {}) {
    const tab = item?.item?.tab;
    const empNo = tab?.emoloyeeNo ?? tab?.employeeNo;
    const fullName = i18n.language === 'en'
      ? `${tab?.nameEn} ${tab?.surNameEn}`
      : `${tab?.name} ${tab?.surName}`;
    const displayName = empNo ? `(${empNo}) ${fullName}` : fullName;
    return (
      <Space direction="horizontal">
        <Flex gap={20} wrap>
          <div>
            <Avatar size={25} src={
              item?.item?.tab?.image
                ? "data:image/png;base64, " + item?.item?.tab?.image
                : <UserIcon />} />
          </div>

          <Flex justify="flex-start" style={{ flex: 1, minWidth: 0 }}>
            <div style={{ width: '100%' }}>
              <Tooltip title={displayName} placement="rightTop">
                <span
                  style={{
                    display: 'block',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {displayName}
                </span>
                <small>desc</small>
              </Tooltip>
            </div>
          </Flex>
        </Flex>
      </Space>

    );
  }

  return (
    <Flex vertical={true} style={{
      // height: "100vh"
    }}>
      <Menu
        style={{
          padding: 10,
          height: "100%",
          width: "16vw",
          borderRadius: '0.5rem'
        }}
        selectedKeys={[selectedKey]}
      >
        {/* <Input allowClear onChange={(e) => {
          setSearch(e.target.value)
        }}
          addonAfter={<span>{t("common.search")}</span>}
          style={{ paddingBottom: "8px" }}
        /> */}

        <Search
          allowClear
          enterButton={t("common.search")}
          style={{ paddingBottom: "8px" }}
          className={styles.searchButton}
          onSearch={(value) => {
            setSearch(value);
            setPagination({ page: 0, size: 15, pageSize: 15 });
            getAllEmployee(value);
          }}
        />

        <List
          loading={isLoading}
          dataSource={employeeList()}
          renderItem={(item) => (
            <Menu.Item key={item?.key}
              onClick={() => handleMenuClick(item)}
              style={{ backgroundColor: selectedKey === item?.key ? 'var(--sidebar-menu-color)' : 'transparent' }}
            >
              <Employee item={item}></Employee>
            </Menu.Item>
          )}
          pagination={{
            current: pagination.page + 1,
            pageSize: pagination.pageSize,
            total: total,
            onChange: (page, pageSize) => {
              setPagination((prev) => ({ ...prev, page: page - 1, pageSize }));
            },
            showSizeChanger: false
          }}
        >
        </List>
      </Menu>
    </Flex>
  );
}

export default EmployeeList;
